export default {
  en: {
    areYouSureDeleteInvite: 'Are you really sure you want to cancel the following invitation? | Are you really sure you want to cancel the following invitations?',
    cancelInvite: 'Cancel invite | Cancel {nb} invites',
    keepInvite: 'Keep invite | Keep {nb} invites',
    pending: '@:Pending',
    pendingInvite: 'Pending invite',
    registered: 'Registered',
    removeMember: 'Remove member',
    resendInvite: 'Resend invite',
    confirmResendTitle: 'Resend invitation | Resend invitations',
    resendInvitesBtn: 'Resend invitation | Resend {nb} invitations',
    userType: {
      hint: 'This impacts the type of seat to consume from your subscription.',
      label: 'User type',
      noAvailableSeatsError: 'You do not have enough available seats of this type. Please contact us to purchase additional seats.',
      seatsAvailable: 'no available seats | {n} available seat | {n} available seats',
    },
    viewProfile: 'View profile',
  },
  es: {
    areYouSureDeleteInvite: '¿Está realmente seguro de que desea cancelar la siguiente invitación? | ¿Está realmente seguro de que desea cancelar las siguientes invitaciones?',
    cancelInvite: 'Cancelar invitación | Cancelar {nb} invitaciones',
    keepInvite: 'Mantener invitación | Mantener {nb} invitaciones',
    pending: '@:Pending',
    pendingInvite: 'Invitación pendiente',
    registered: 'Registrado',
    removeMember: 'Eliminar miembro',
    resendInvite: 'Reenviar invitación',
    confirmResendTitle: 'Reenviar la invitación | Reenviar invitaciones',
    resendInvitesBtn: 'Reenviar la invitación | Reenviar {nb} invitaciones',
    userType: {
      hint: 'Esto impacta el tipo de asiento que se consumirá de su suscripción.',
      label: 'Tipo de usuario',
      noAvailableSeatsError: 'No tiene suficientes asientos disponibles de este tipo. Por favor contáctenos para comprar asientos adicionales.',
      seatsAvailable: 'sin asientos disponibles | {n} asiento disponible | {n} asientos disponibles',
    },
    viewProfile: 'Ver perfil',
  },
  fr: {
    areYouSureDeleteInvite: `Êtes-vous vraiment sûr de vouloir annuler l'invitation suivante? | Êtes-vous vraiment sûr de vouloir annuler les invitations suivantes?`,
    cancelInvite: `Annuler l'invitation | Annuler {nb} invitations`,
    keepInvite: `Conserver l'invitation | Conserver {nb} invitations`,
    pending: '@:Pending',
    pendingInvite: 'Invitation en attente',
    registered: 'Enregistré',
    removeMember: 'Retirer le membre',
    resendInvite: `Renvoyer l'invitation`,
    confirmResendTitle: 'Renvoyer une invitation | Renvoyer des invitations',
    resendInvitesBtn: 'Renvoyer une invitation | Renvoyer {nb} invitations',
    userType: {
      hint: 'Cela affecte le type de siège à consommer à partir de votre abonnement.',
      label: `Type d'utilisateur`,
      noAvailableSeatsError: `Vous n'avez pas suffisamment de sièges disponibles de ce type. Veuillez nous contacter pour acheter des sièges supplémentaires.`,
      seatsAvailable: 'aucun siège disponible | {n} siège disponible | {n} sièges disponibles',
    },
    viewProfile: 'Voir le profil',
  },
}
